import { Component, OnInit, HostListener } from '@angular/core';

import { IImage } from 'ng-simple-slideshow';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  height: number = null;
  width: number = null;

  images: IImage[] = [
    {
      url: '../assets/img/banner1.jpg'
    },
    {
      url: '../assets/img/banner2.jpg'
    },
    {
      url: '../assets/img/banner3.jpg'
    },
    {
      url: '../assets/img/banner4.jpg'
    }
  ];

  imagesMobile: IImage[] = [
    {
      url: '../assets/img/banner-1-mobile.jpg'
    },
    {
      url: '../assets/img/banner-2-mobile.jpg'
    },
    {
      url: '../assets/img/banner-3-mobile.jpg'
    },
    {
      url: '../assets/img/banner-4-mobile.jpg'
    }
  ];

  constructor() { }

  ngOnInit() {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
  }

  get resizeSlider() {
    const height = this.height;

    if (this.width < 1100) {
      return (height - 77.19).toString() + 'px';
    } else {
      return height.toString() + 'px';
    }
  }

  get banners() {
    if (this.width <= 500) {
      return this.imagesMobile;
    } else {
      return this.images;
    }
  }
}
